import { semanticThemeTokens } from "@appretio/ui-kit";
import { Outlet, type RouteObject } from "react-router-dom";
import { PlaybookPage } from "./pages/playbookPage/PlaybookPage";
import { TradexPage } from "./pages/tradexPage/TradexPage";

const ROOT = "lifecycle" as const;

const PATH = {
  PLAYBOOK: "playbook",
  TRADEX: "tradex"
} as const;

const LABEL = {
  ROOT: "Lifecycle",
  PLAYBOOK: "Playbook",
  TRADEX: "Tradex"
} as const;

const BG = semanticThemeTokens.backgroundGradient[4];

export const lifecycleRoutes: RouteObject = {
  path: ROOT,
  element: <Outlet />,
  handle: { label: LABEL.ROOT, background: BG },
  children: [
    {
      path: PATH.PLAYBOOK,
      handle: { label: LABEL.PLAYBOOK },
      element: <PlaybookPage />
    },
    {
      path: PATH.TRADEX,
      handle: { label: LABEL.TRADEX },
      element: <TradexPage />
    }
  ]
};
